export default __webpack_public_path__ + "static/media/ic_visibility_2.551a08f6.svg";